import { Dispatch } from 'application/redux'
import { addToaster } from "core/toaster/redux/actions"
import { ToasterType } from "core/toaster/redux/types"
import { t } from "i18next"
import { GeneralDeviceState } from "modules/operational/device/detail/general/redux/types"


export type ExecuteCommandType = (allowCommandExecution: boolean, commandName: string, commandCallback: Function) => void

export function executeCommand(...[allowCommandExecution, commandName, commandCallback]: Parameters<ExecuteCommandType>) {
  return function (dispatch: Dispatch) {
    if (allowCommandExecution) {
      return commandCallback()
    }

    return dispatch(
      addToaster({
        title: t(commandName),
        message: t('error_messages.VIPOC_ERROR_068'),
        type: ToasterType.danger,
      })
    )
  }
}

export function isDeviceOnline(general: GeneralDeviceState) {
  return general?.shadow?.reported?.status?.connected === 'true'
}